import { Component } from '@angular/core';
import { InformacionService } from "../../services/informacion.service";
import { TranslateService } from 'ng2-translate';


@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html'
})
export class ContactoComponent {

  constructor ( public _is:InformacionService, private translate:TranslateService ){

  }

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/contacto/contacto.component.ts